import { Form } from '@fulcrumapp/fulcrum-core';
import {
  FormSchema, Expression, Converter, Query,
} from 'fulcrum-query-sql';
import Deparse from '@fulcrumapp/pg-query-deparser';
import Client from '../../../api/client';
import { LoadRecordsOptions } from '../functions';
import buildFormColumns from '../../../hooks/helpers/form-columns-builder';

async function getRawColumns(api, formID: string) {
  const columns = (await api.query.run({ q: formColumnsSql(formID) })).objects;
  return buildFormColumns(columns);
}

function transformPredicates(rawColumns, whereClause, schema) {
  const fields = [...rawColumns.form];

  const fieldMap = fields.reduce((map, field) => ({
    ...map,
    [field.name]: field.field,
  }), {});

  const operatorMap = {
    equal_to: 'equal',
    not_equal_to: 'not_equal',
    contains: 'text_contain',
    starts_with: 'text_starts_with',
  };

  const updatedPredicates = whereClause.predicates.map((predicate) => ({
    ...predicate,
    field: fieldMap[predicate.field] || predicate.field,
    operator: operatorMap[predicate.operator] || predicate.operator,
    value: Array.isArray(predicate.value) ? predicate.value : [predicate.value],
  }));

  const expressions = updatedPredicates.map((element) => new Expression(element, schema));

  return expressions;
}

export async function buildWhereClause(api: Client, formID: string, options: LoadRecordsOptions) {
  // @ts-ignore
  const formJson = await api.forms.find(formID);
  const rawColumns = await getRawColumns(api, formID);
  const form = new Form(formJson);
  const schema = new FormSchema(form, rawColumns.form, rawColumns.repeatables, { fullSchema: true });

  const whereClause = options.where;
  const expressions = transformPredicates(rawColumns, whereClause, schema);
  // @ts-ignore
  const filter = { type: whereClause.operator, expressions };
  const query = new Query({
    form, schema, filter,
  });
  // @ts-ignore
  const whereClauseConverter = new Converter().whereClause(query);
  return disambiguateColumns(new Deparse().deparse(whereClauseConverter));
}

function disambiguateColumns(whereClause) {
  return whereClause ? whereClause.replace(/"name"/g, 'records.name') : '';
}

export function buildOrderClauses(orderArray) {
  if (Array.isArray(orderArray)) {
    const orderClauses = orderArray.map((item) => {
      if (Array.isArray(item) && item.length === 2) {
        const [columnRaw, direction] = item;
        const column = columnRaw === 'name' ? 'records.name' : columnRaw;
        return `${column} ${direction}`;
      }
      return '';
    }).filter(Boolean);

    if (orderClauses.length) {
      return orderClauses.join(', ');
    }
  }
  return '';
}

function formColumnsSql(formID: string) {
  return `
  SELECT
  tables.field AS table_field,
  columns.name,
  columns.field,
  columns.part,
  columns.type
  FROM columns
  INNER JOIN tables ON columns.table_name = tables.name
  WHERE
  tables.form_id = '${formID}' AND tables.type IN ('repeatable', 'form')
  ORDER BY columns.table_name, columns.ordinal
  `;
}
